<template>
  <svg :width="width"
       :height="height"
       version="1.1"
       role="presentation"
       viewBox="0 0 100 100"
       xmlns="http://www.w3.org/2000/svg"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="m50 65.297c-8.4336 0-15.297-6.8633-15.297-15.297s6.8633-15.297 15.297-15.297 15.297 6.8633 15.297 15.297-6.8633 15.297-15.297 15.297zm0-25.031c-5.3672 0-9.7344 4.3672-9.7344 9.7344s4.3672 9.7344 9.7344 9.7344 9.7344-4.3672 9.7344-9.7344-4.3672-9.7344-9.7344-9.7344z"/>
      <path d="m50 77.812c-21.965 0-39.137-25.188-39.855-26.262-0.62891-0.9375-0.62891-2.1641 0-3.1016 0.71875-1.0703 17.891-26.262 39.855-26.262s39.137 25.188 39.855 26.262c0.62891 0.9375 0.62891 2.1641 0 3.1016-0.71875 1.0703-17.891 26.262-39.855 26.262zm-34.113-27.812c3.9766 5.2852 18 22.25 34.113 22.25s30.137-16.965 34.113-22.25c-3.9766-5.2852-18-22.25-34.113-22.25s-30.137 16.965-34.113 22.25z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>